import toast from "react-hot-toast";
import tryParseJSON from "./try-parse-json";

const MAX_TOAST_MESSAGE_LENGTH = 3;

function capitalizeFirstLetter(str: string): string {
  return str?.charAt(0).toUpperCase() + str?.slice(1);
}

function showToastError(message: string, duration: number = 3000): void {
  toast.error(capitalizeFirstLetter(message), { duration });
}

function handleStringError(error: string): void {
  const parsedError = tryParseJSON(error);

  if (parsedError && typeof parsedError == 'object') {
    handleObjectError(parsedError);
  } else {
    showToastError(error, 3000);
  }
}

function handleObjectError(error: any): void {
  if (error.response?.data?.message) {
    const messages = Array.isArray(error.response.data.message)
      ? error.response.data.message
      : [error.response.data.message];

    messages
      .slice(0, MAX_TOAST_MESSAGE_LENGTH)
      .forEach((msg: string) => showToastError(msg, 3000));
  } else if (error.message) {
    handleStringError(error.message);
  }
}

function httpErrorMessage(err: any): void {
  if (!err) return;

  if (typeof err === "string") {
    handleStringError(err);
  } else if (typeof err === "object") {
    handleObjectError(err);
  }
}

export default httpErrorMessage;
